var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.href
    ? _c(
        "a",
        _vm._b(
          { attrs: { href: _vm.href, target: "_blank" } },
          "a",
          _vm.$attrs,
          false
        ),
        [_vm._t("default")],
        2
      )
    : _c(
        "RouterLink",
        _vm._b(
          {
            class:
              ((_obj = {}),
              (_obj[_vm.exactActiveClass] = _vm.subIsActive(
                "/carteira",
                _vm.routerLinkTo
              )),
              _obj),
            attrs: { to: _vm.routerLinkTo }
          },
          "RouterLink",
          _vm.$attrs,
          false
        ),
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }